import React, { useEffect, useState } from "react";
import Navbar from "Common/Frontend/Navbar";
import Footer from "Common/Frontend/Footer";
import { getLang, subscribe } from "../utils/translator";
import "assets/scss/frontend/frontend.scss";
import FrontSideRoutes from "FrontSideRoutes/FrontSideRoutes.jsx";
import { BookingProvider } from "../Context/BookingContext";
import { AuthProvider } from "../Context/AuthContext";
import { CurrencyProvider } from "../Context/CurrencyContext";

const FrontendLayout = () => {
  const [currentLang, setCurrentLang] = useState(getLang());

  useEffect(() => {
    // Subscribe to language changes and re-render when language switches
    const unsubscribe = subscribe(() => setCurrentLang(getLang()));
    return unsubscribe;
  }, []);

  return (
    // id must be a single token — lang goes on a separate attribute
    <div id="root-container" lang={currentLang} className="frontend-site">
      <AuthProvider>
        <CurrencyProvider>
          <BookingProvider>
            <Navbar />
            <main className="frontend-main">
              <FrontSideRoutes />
            </main>
            <Footer />
          </BookingProvider>
        </CurrencyProvider>
      </AuthProvider>
    </div>
  );
};

export default FrontendLayout;
